import {Directive, ElementRef, EventEmitter, Output, NgZone} from '@angular/core';
import {NgModel} from '@angular/forms';

declare var google: any;

@Directive({
  selector: '[googleplace]',
  exportAs: 'wego-googleplace',
  providers: [NgModel],
  host: {
    '(input)': 'onInputChange()'
  }
})
export class GoogleplaceDirective {
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @Output() setInputAddressValue: EventEmitter<any> = new EventEmitter();
  modelValue: any;
  autocomplete: any;
  private _el: HTMLElement;
  private _ngZone: NgZone;
  private location_being_changed: boolean;
  private inputfunctionvalue : string;
  private matchstatus : boolean;

  constructor(el: ElementRef, private model: NgModel) {
    this._el = el.nativeElement;
    this.modelValue = this.model;

    var input = this._el;
    var options = {
      componentRestrictions: { country: "nl" }
    };

    this.autocomplete = new google.maps.places.Autocomplete(input, options);
    // el.nativeElement.trigger("blur");

    google.maps.event.addListener(this.autocomplete, 'place_changed', () => {

      this.location_being_changed = false;
      // this.autocomplete.addListener('place_changed', () => {

      console.log(el.nativeElement.value);
      let place = this.autocomplete.getPlace();
      var address = { lat: 0, log: 0, address: '', isAdddressfound: false , useraddressInput : '' };
      address.useraddressInput = el.nativeElement.value;
      if (place) {
        var location = place['geometry']['location'];
        address.address = el.nativeElement.value;
        if (location) {
          //  this.model.vehicleGeoLocationAddress = place['formatted_address'];
          address.lat = location.lat();
          address.log = location.lng();
          address.isAdddressfound = true;
         
        }
        else {
          address.lat = 0;
          address.log = 0;
          address.isAdddressfound = false;
        }

      }
      else {
        address.lat = 0;
        address.log = 0;
        address.isAdddressfound = false;
      }
      console.log("autocomplete value", address);
      this.invokeEvent(address);
    });
  }


  invokeEvent(address: Object) {
    this.setAddress.emit(address);
  }



  onInputChange() {
    this.autocomplete.set('place',null);
    google.maps.event.trigger(this.autocomplete, 'place_changed');
  }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/plugins/googleaddressautocomplete/google-address-autocomplete.ts